import { Persona } from "./types";

export const mockPersona: Persona = {
  profile: {
    name: "Tiago Santos",
    gender: "Masculino",
    age: "30 anos",
    marital_status: "Solteiro",
    profession: "Criador de JSONs",
    monthly_income: "R$ 7000",
    location: "São Paulo – SP",
    education: "Graduação",
    hobbies: ["Fotografia", "Culinária", "Corrida"],
    interpersonal_skill: "Liderança",
    technical_skill: "Estratégia Digital",
    social_networks: ["Facebook", "Instagram", "LinkedIn"],
    favorite_brands: ["Nike", "Samsung"],
    bio: "Apaixonado por comunicação digital, habita uma metrópole…",
    personality: "Dotado de uma personalidade extrovertida e confiante…",
    daily_routine: "Começa o dia com uma corrida matinal no parque vizinho…",
    neighborhood: "Reside em um bairro urbano movimentado de São Paulo…",
  },
  past_and_future: {
    personal_history: "Seus objetivos foram moldados por uma infância…",
    professional_journey: "Iniciou sua carreira em startups, onde o dinamismo…",
  },
  internal_factors: {
    inspirations: "Mentores do passado e experiências multiculturais moldaram…",
    motivations: "Movido pela paixão em impactar o setor de comunicação…",
    personal_goals:
      "Apaixonado por tecnologia e criatividade, busca equilibrar…",
    personal_success: "Para ele, sucesso pessoal é viver em harmonia com suas…",
    personal_challenges_and_frustrations: "Desafios como gerenciamento…",
    dreams: "Se ele tivesse um sonho distante, seria o de…",
    fears: "Seu medo mais profundo é o de ser esquecido em um mundo…",
  },
  professional_life: {
    professional_goals: "Com ambição de se destacar na comunicação digital…",
    professional_success: "Define sucesso profissional como a habilidade de…",
    professional_challenges: "Certa vez, uma campanha de marketing…",
  },
  discovery_and_journey: {
    new_product_discovery: "Descobriu ferramentas como Slack e Trello…",
    common_shopping_experience: "Recentemente, ao considerar a compra de…",
    positive_shopping_experience: "Durante um projeto importante, descobriu…",
  },
  external_influences: {
    how_decides_to_buy: "Recentemente, um colega influenciou a decisão…",
    valued_features: "Em um dia típico ao deparar-se com um novo produto…",
    other_influences: "Consultores e colegas de trabalho influenciam suas…",
  },
  pain_and_competition: {
    specific_problems: "Gostaria de encontrar soluções mais eficazes…",
    current_solutions_used: "Atualmente utiliza plataformas como Hootsuite…",
    likes_in_current_solutions:
      "Aprecia a interface intuitiva e acessibilidade…",
    unlikes_in_current_solutions:
      "Sente que o Hootsuite, às vezes, é limitado…",
  },
};
